export function createElement(tag, attrs = {}, children = []) {
  const node = document.createElement(tag)

  Object.entries(attrs).forEach(([key, value]) => {
    if (value === null || value === undefined || value === false) return

    if (key === "text") {
      node.textContent = String(value)
    } else if (key === "class") {
      node.className = value
    } else if (key === "dataset") {
      Object.entries(value).forEach(([dataKey, dataValue]) => {
        if (dataValue === null || dataValue === undefined) return
        node.dataset[dataKey] = String(dataValue)
      })
    } else if (value === true) {
      node.setAttribute(key, "")
    } else {
      node.setAttribute(key, String(value))
    }
  })

  toArray(children).forEach((child) => {
    if (child === null || child === undefined || child === false) return
    node.appendChild(typeof child === "string" ? document.createTextNode(child) : child)
  })

  return node
}

export function clearNode(node) {
  if (!node) return
  while (node.firstChild) node.removeChild(node.firstChild)
}

export function isElement(node) {
  return Boolean(node) && typeof node === "object" && node.nodeType === 1
}

export function setHidden(node, hidden) {
  if (!node) return
  if (hidden) {
    node.setAttribute("hidden", "")
  } else {
    node.removeAttribute("hidden")
  }
}

export function focusNode(node) {
  if (!node || typeof node.focus !== "function") return
  try {
    node.focus()
  } catch {
    /* no-op */
  }
}

export function toArray(value) {
  if (Array.isArray(value)) return value
  if (value === null || value === undefined) return []
  return [value]
}

export function langText(tag, className, value) {
  const source = value && typeof value === "object" ? value : {}
  return createElement(tag, {
    class: className,
    lang: typeof source.lang === "string" && source.lang ? source.lang : null,
    text: typeof source.text === "string" ? source.text : ""
  })
}
